module.exports = __webpack_public_path__ + "img/photo.e9b69f1b.svg";